import { createTheme } from "@mui/material/styles";
import { border, padding } from "@mui/system";

export const ScreenHeights = {
  userTableHeight: "calc(100vh - 190px - 62px)",
  contentContainerHeight: "calc(100vh - 190px)",
};

export const Theme = createTheme({
  typography: {
    h1: {
      fontFamily: "Poppins",
      fontWeight: 700,
      fontSize: { xs: "30px", md: "40px", lg: "50px" }, // Adjust font size for different screen sizes,
      padding: "15px 0px",
      color: "white",
    },
    h2: {
      fontFamily: "Poppins",
      fontWeight: 700,
      fontSize: "20x",
      padding: "15px 0px",
      color: "white",
    },
    h3: {
      fontFamily: "Poppins",
      fontWeight: 700,
      fontSize: "50px",
      padding: "15px 0px",
      color: "white",
    },

    body0: {
      fontSize: "16px",
      fontFamily: "Poppins",
      color: "white",
      textAlign: "left",
      justifyContent: "space-between",
    },
    body1: {
      fontSize: "20px",
      padding: "15px 0px",
      fontFamily: "Poppins",
      color: "white",
    },
    body2: {
      fontSize: "14px",
      padding: "5px 20px",
      fontFamily: "Poppins",
      color: "white",
    },
    body3: {
      fontSize: "14px",
      fontFamily: "Poppins",
      color: "white",
      //   textAlign: "left",
    },
    body4: {
      fontSize: "14px",
      fontFamily: "Poppins",
      color: "white",
      textAlign: "left",
    },
  },
  components: {
    MuiBox: {
      variants: [
        {
          props: { variant: "customBoxPrimary" },
          style: {
            margin: "20px",
            maxWidth: "800px",
            width: "100%",
            background: "rgba(255, 255, 255, 0.1)", // Add translucent background
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
          },
        },
        {
          props: { variant: "customBoxSecondary" },
          style: {
            background: "#001d32", // Add translucent background
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            margin: "20px",
            minHeight: "290px",
            justifyContent: "left",
          },
        },
      ],
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none", // Remove shadow
          border: "none",
          backgroundColor: "#F0FCFA",
          display: "flex",
          borderRadius: "10px",
          padding: "10px 20px",
          margin: "20px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          textTransform: "none",
          fontFamily: "Poppins",
          fontSize: "16px",
          backgroundColor: "#279989",
          boxShadow: "none",
          color: "white",
          borderRadius: "8px",
          padding: "8px 35px",
          "&:hover": {
            backgroundColor: "#1e7b6c", // Hover color
          },
        },
        outlinedSecondary: {
          textTransform: "none",
          fontFamily: "Poppins",
          fontSize: "16px",
          backgroundColor: "white",
          color: "#279989",
          boxShadow: "none",
          borderRadius: "8px",
          border: "1px solid #279989",
          padding: "5px 14px",
          "&:hover": {
            backgroundColor: "#279989", // Hover color
            color: "#ffffff",
            border: "1px solid #279989",
          },
          "&:disabled": {
            backgroundColor: "#E8E8E8", // Hover color
            color: "#279989",
            border: "1px solid #279989",
          },
        },
        customtab: {
          textTransform: "none",
          fontFamily: "Poppins",
          fontSize: "16px",
          //backgroundColor: "#279989",
          boxShadow: "none",
          //color: "white",
          minWidth: "130px",
          borderRadius: "8px 8px 0px 0px",
          padding: "6px 10px",
          margin: "0px 10px",
          "&:hover": {
            backgroundColor: "#279989", // Hover color
            color: "#fff",
          },
        },
        customcancel: {
          textTransform: "none",
          width: "140px",
          fontFamily: "Poppins",
          fontSize: "16px",
          marginRight: "10px",
          backgroundColor: "#FAE2E2",
          color: "#D84141",
          borderRadius: "8px",
          border: "1px solid #D84141",
          padding: "5px 10px",
          "&:hover": {
            backgroundColor: "#D84141", // Hover color
            color: "#ffffff",
            border: "1px solid #D84141",
          },
        },
        customsave: {
          textTransform: "none",
          width: "140px",
          fontFamily: "Poppins",
          fontSize: "16px",
          marginLeft: "10px",
          backgroundColor: "#F1FFF3",
          color: "#279989",
          borderRadius: "8px",
          border: "1px solid #279989",
          padding: "5px 10px",
          "&:hover": {
            backgroundColor: "#279989", // Hover color
            color: "#ffffff",
            border: "1px solid #279989",
          },
        },
        startIcon: {
          marginRight: "4px", // Reduce the margin between the icon and text
        },
      },
    },
  },
  spacing: 5,
});
